import { DeflistSpecs } from './DeflistSpecs';
import { splitDeflist, wrapToDeflist } from './commands';
import { dlAction } from './const';
export { DeflistNode, defListType, defTermType, defDescType } from './DeflistSpecs';
export const Deflist = (builder, opts) => {
    builder.use(DeflistSpecs, opts);
    builder.addKeymap(() => ({ Enter: splitDeflist }));
    builder.addAction(dlAction, () => {
        return {
            isEnable: wrapToDeflist,
            run: wrapToDeflist,
        };
    });
};
